//菜单
export const menu = {
  enterprise: "企业",
  vn: "多点组网",
  product: "产品",
  mobility: "移动应用",
  technology: "技术",
  download: "资料下载",
  aboutUs: "关于我们",
  awards: "奖项",
  news: "新闻资讯",
};

export const enterprise = {
  t: "企业的IT服务正逐步向混合云迁移",
  c: "业务虚拟化已有比较成熟的方案，但网络连接只完成了局域网虚拟化，广域网连接仍停留在传统模式。广域网连接虚拟化，需要数据的控制，面向统一管理、调度、配置，数据的转发面向资源的集中和分享。",
  t1: "基于SD WAN架构的广域网部署，协助企业混合组网",
  c1: "通过多类型 SD-WAN CPE，经Internet连接云端POP点，实现快速、便捷、高质量、低成本混合组网。支持传统广域网组网向 SD-WAN 平滑演进，保护现有投资和业务一致性同时，助力企业数据中心逐步向云端迁移。",
  t2: "SD-WAN云快线解决方案 - 智能广域网",
  c2: "国内外分公司/分支机构/客户总部/数据中心之间的企业跨境组网，对应专线或MPLS，实现国内3层连接的高速低延迟混合云互联，建议每路高清会议使用4M及以上带宽，企业内部组网后，所有数据在内网传输，AES256 加密可保证数据安全，支持混合组网，充分利用现有投资，支持低成本扩展，SD-WAN集中控制系统，可将配置与安全策略统一推送到各接入点。",
  kt: "降低成本",
  kt1: "高质量",
  kt2: "快递交付",
  kt3: "易管理",
  kt4: "高可用",
  kt5: "灵活性",
  kc: "相比现有 MPLS/专线方案成本与 TCO 降低 80%",
  kc1: "整体组网基于 SD-WAN技术，可以有效保证线路稳定性",
  kc2: "一周之内开通业务，分支机构零配置",
  kc3: "全球分支机构统一管理配置、统一监控网络情况",
  kc4: "所有分支机构采用主备方案",
  kc5: "对比MPLS/专线，有更强的虚拟化能力，支持更丰富快速的组网方案",
};

//多点组网
export const vn = {
  t: "多点组网解决方案",
  c: "办公点只需要连接公网，即可组网，分支地区通过专线或宽带直接接入SD-WAN骨干接入点，西北地区使用 FastIP 技术优化公网传输后接入华中接入点或云中继点，省内使用 FastIP 技术优化公网传输后直连总部，支持设备与链路级的主备或双活模式。",
  cc: "无需更改现有系统架构，无需预先投资任何固定资产，节约建设与维护成本，在不增加成本的前提下，通过算法优化传输质量，部署周期快，全网统一可视化管理，支持混合组网，充分利用现有资源，AES-256 强加密方式，保证客户数据安全。",
  t1: "分支店面组网架构",
  c1: "支持多种接入模式，LTE，宽带及MPLS。根据各个分支机构使用不同类型设备支持不同的用户量。分支门店使用S/D系列设备。总部使用R设备。",
};

//移动应用
export const mob = {
  t: "多平台客户端应用程序，提升移动办公、远程办公效率",
  c: "我们有windows、mac、android、ios等多平台客户端程序，可使用欧深网络所有服务的通用客户端，可支持所有主流移动及桌面设备，可通过任意设备享受安全便捷的网络接入",
  f: "使用服务后可在不同国家间做跨国高速访问",
  f1: "支持多种桌面与移动系统",
  f2: "一键登录高速安全的加密链路",
  f3: "支持企业账户无缝对接",
  go: "前往下载",
};
//设备
export const dv = {
  //rx
  rxs: "标准1U",
  rxu: "人",
  rxesim: "内置esim",
  rxno: "无",
  rxv100: "根据云主机配置",
  rxv100a: "云主机虚拟镜像",
  rxv100u: "公有云/私有云主机",
  rxv100t: "虚拟设备",
  rxv100t1: "虚拟边缘连接器",
  rxv100t2: "适用公有云 私有云平台",
  dtt: "高性能中小型设备",
};

export default { menu, enterprise, vn, mob, dv };



// WEBPACK FOOTER //
// ./src/i18n/ch.js